export default "__VITE_ASSET__DOL_e_Lt__"